import api from "../../api";
import { adapterOptions, NAConverter } from '../../utils';
import { adapterTags } from '../../utils/adapter-tags';

const subAdapter = {
  file: {
    responseBodyToForm(input){
      let output = {}

      if(input){
        const {
          pkFileId,
          typeResources,
          binFile,
          embedLink = '',
          deskripsiFile = []
        } = input

        /**
         * @todo fix type adapter
         */
        const type = typeResources

        output = {
          id: pkFileId,
          type,
          url: api.base_image+binFile,
          embedLink,
          description: {
            en: deskripsiFile[1],
            id: deskripsiFile[0]
          }
        }
      }

      return output
    },
    formToRequestBody(input){
      let output = {}

      if(input){
        const {
          type,
          embedLink,
          description_en,
          description_id,
          submission,
        } = input

        output = {
          typeResources: type,
          embedLink: embedLink,
          deskripsiFile: [description_id, description_en],
          typeVisibility: 1,
          submission
          // isLimitedaccess: 1,
        }
      }

      return output
    }
  }
}

const adapter = {
  responseBodyToForm(input){
    let output = {}

    if(input){
      const {
        resourceId,
        imgMainImage,
        imgThumbnail,
        // kategoriArtikel,
        judulArtikel,
        deskripsiPendek,
        typeAudience,
        typeApproach,
        typeIssues,
        resourcesTag,
        resourcesFiles,
        kategoriArtikel,
        submission,
        catatanModerasi
      } = input

      const file = resourcesFiles

      output = {
        id: resourceId,
        title_en: judulArtikel[1],
        title_id: judulArtikel[0],
        type: 'embed',
        about_en: deskripsiPendek[1],
        about_id: deskripsiPendek[0],
        visibility: 'public',
        categories: matchCategories(kategoriArtikel),
        suitable: adapterOptions(typeAudience),
        suitable__en: adapterOptions(typeAudience, 1),
        approach: adapterOptions(typeApproach),
        approach__en: adapterOptions(typeApproach, 1),
        issue: adapterOptions(typeIssues),
        issue__en: adapterOptions(typeIssues, 1),
        tags: adapterTags(resourcesTag),
        image: api.base_image+imgMainImage,
        thumbnail: api.base_image+imgThumbnail,
        file: subAdapter.file.responseBodyToForm(file),
        // files: resourcesFiles.map(file => subAdapter.file.responseBodyToForm(file)),
        files: [subAdapter.file.responseBodyToForm(file)],
        file_from_api: resourcesFiles,
        // files: [],
        submission_status_id: submission,
        reason: catatanModerasi
      };
    }

    return output
  },
  formToRequestBody(input){
    let output = {}

    if(input){
      const {
        title_id,
        title_en,
        about_id,
        about_en,
        suitable = [],
        approach = [],
        issue = [],
        tags,
        file,
        categories,
        submission
      } = input

      output = {
        judulArtikel: [title_id, title_en],
        deskripsiPendek: [NAConverter(about_id), NAConverter(about_en)],
        deskripsiPanjang: [NAConverter(about_id), NAConverter(about_en)],
        typeAudience: suitable.map((s) => s.value),
        resourcesTag: tags.map((s) => s.value),
        kategoriArtikel: categories ? categories : [],
        typeApproach: approach.map((s) => s.value),
        typeIssues: issue.map((s) => s.value),
        resourcesGalleries: [
          {
            deskripsiGambar: [
              "Contoh Deskripsi Gambar 1",
              "Example Picture Description 1",
            ],
            typeVisibility: 1,
          },
        ],
        typeVisibility: 1,
        typeSensitivity: 1,
        vsbJudulArtikel: 1,
        vsbThumbnail: 1,
        vsbMainImage: 1,
        vsbKategoriArtikel: 1,
        vsbDeskripsiPendek: 1,
        vsbDeskripsiPanjang: 1,
        vsbTypeAudience: 1,
        vsbTypeApproach: 1,
        vsbTypeIssues: 1,
        submission,
      }

      if(file){
        const withBlob = file && file.blob && file.blob.url && file.blob.url.slice(0,4) === 'blob'
        const withEmbedLink = file && file.embedLink && file.embedLink !== 'https://'
        const files = withBlob || withEmbedLink ? subAdapter.file.formToRequestBody(file) : false

        if(files){
          output = {
            ...output,
            // resourcesFiles: [],
            resourcesFiles: files,
            // resourcesFiles: subAdapter.file.formToRequestBody(file),
            // resourcesFiles: [
            //   {
            //     typeResources: 2,
            //     deskripsiFile: [
            //       "Contoh Deskripsi File 1",
            //       "Example File Description 1",
            //     ],
            //     typeVisibility: 1,
            //     isLimitedaccess: 1,
            //   },
            //   {
            //     typeResources: 1,
            //     embedLink: "https://issuu.com/pixelpi.site/docs/blank_black",
            //     deskripsiFile: ["Deskripsi File 1", "File Description 1"],
            //     typeVisibility: 1,
            //     isLimitedaccess: 1,
            //   },
            // ],
          }
        }
      }
    }

    return output
  }
}

function matchCategories(payload) {
  let result = [];

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index];
      result.push(element.id)
    }
  }

  return result
}

export default adapter
